/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import storage from "local-storage-fallback";
import { useNavigate } from "react-router-dom";
import jwtDecode, { JwtPayload } from "jwt-decode";
import { useEffect, useState } from "react";
import { useApolloClient } from "@apollo/client";

import { setAuth } from "../hooks/auth";
import config from "../config/config";

const { API_URL, REFRESH_TOKEN, TOKEN } = config;

export const saveToken = (token: string) => storage.setItem(TOKEN, token);
export const saveRefreshToken = (refreshToken: string) =>
  storage.setItem(REFRESH_TOKEN, refreshToken);
export const getToken = (): string | null => storage.getItem(TOKEN);
export const getRefreshToken = (): string | null =>
  storage.getItem(REFRESH_TOKEN);
export const clearToken = () => storage.removeItem(TOKEN);
export const clearRefreshToken = () => storage.removeItem(REFRESH_TOKEN);

export const logout = () => {
  const navigate = useNavigate();
  const client = useApolloClient();
  client.cache.reset();
  client.clearStore();
  clearToken();
  clearRefreshToken();
  setAuth(false);
  navigate("/");
};

const headers = {
  "Content-Type": "application/json; charset=utf-8",
  Authorization: `JWT ${getToken()}`,
  Accept: "application/json",
};

export const isAuthenticated = (): boolean => {
  const token = getToken();
  if (!token) return false;

  try {
    const { exp }: JwtPayload = jwtDecode(token);
    if (Date.now() >= exp! * 1000) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};

export const usePrepareApp = () => {
  const token = getToken();
  const refreshToken = getRefreshToken();
  const [isLoading, setIsLoading] = useState(true);
  const { resetStore } = useApolloClient();

  useEffect(() => {
    if (token && refreshToken) {
      fetch(`${API_URL}`, {
        method: "POST",
        body: JSON.stringify({
          query: `mutation {
            refreshToken(token: "${refreshToken}") {
              token,
              refresh_token,
              }
            }`,
        }),
        headers,
      })
        .then(async (res) => res.json())
        .then(async (data) => {
          if (
            data.data &&
            data.data.refreshToken?.token &&
            data.data.refreshToken?.refresh_token
          ) {
            saveToken(data.data.refreshToken?.token);
            saveRefreshToken(data.data.refreshToken?.refresh_token);
            setIsLoading(false);
          } else {
            resetStore();
            clearToken();
            clearRefreshToken();
            setIsLoading(false);
          }
        });
    } else {
      const client = useApolloClient();
      client.cache.reset();
      client.clearStore();
      resetStore();
      clearToken();
      clearRefreshToken();
      setIsLoading(false);
    }
  }, [resetStore]);

  return { isLoading };
};
